module.exports = __webpack_public_path__ + "img/bg_img.9d4857ef.png";